import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table } from "semantic-ui-react";
import { LoaderWithDelay } from "../helpers";
import { recordingList } from "../../actions/recordingActions";
import {
  selectRecordingsForProject,
  applyFilters,
} from "../../selectors/recordingSelector";
import { recordingStatuses, statusText } from "../../constants";
import { RecordingsFilterContext } from "../pages/ProjectPage";

const getBackgroundColor = (recording) => {
  if (recording.user_status !== recordingStatuses.NO_RECORDING) {
    switch (recording.reviewer_status) {
      case recordingStatuses.APPROVED:
        return "#d3f1cb80";
      case recordingStatuses.REDO:
        return "#fdd5d5a8";
      default:
        return "#f5edd4b0";
    }
  }
};

const RecordingList = ({ project }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { filters } = useContext(RecordingsFilterContext);
  const recordings = useSelector((state) =>
    applyFilters(selectRecordingsForProject(state.recordings, project), filters)
  );
  const loading = useSelector((state) => state.recordings.loading[project.id]);
  useEffect(
    () => {
      dispatch(recordingList(project.id));
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      {loading && <LoaderWithDelay size="massive" active />}
      <Table selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>№</Table.HeaderCell>
            <Table.HeaderCell>text</Table.HeaderCell>
            <Table.HeaderCell>filename</Table.HeaderCell>
            <Table.HeaderCell>status</Table.HeaderCell>
            <Table.HeaderCell>reviewer status</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {recordings.map((recording) => (
            <Table.Row
              key={recording.id}
              style={{ backgroundColor: getBackgroundColor(recording) }}
              onClick={() =>
                history.push(`${project.url}/recording/${recording.number}`)
              }
            >
              <Table.Cell>{recording.number}</Table.Cell>
              <Table.Cell>{recording.text}</Table.Cell>
              <Table.Cell>{recording.filename}</Table.Cell>
              <Table.Cell>{statusText(recording.user_status)}</Table.Cell>
              <Table.Cell>{statusText(recording.reviewer_status)}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

RecordingList.propTypes = {
  project: PropTypes.object.isRequired,
};

export default RecordingList;
